import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';

import { App } from 'components/App/App';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(<App />);
} else {
  console.error('Root element not found. Unable to render the app.');
}
